import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useActiveReportStore } from './useActiveReportStore';

/**
 * Hook to clear the currentReport from useActiveReportStore when navigating to non-report pages
 * like /bookkeeper, /admin, /new-dashboard, etc.
 */
export const useClearReportOnNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;

    // Define patterns for non-report pages that should clear the currentReport
    const nonReportPages = ['/bookkeeper', '/admin', '/new-dashboard', '/queue', '/ask-requests'];

    // Check if current path matches any non-report page patterns
    const isNonReportPage = nonReportPages.some(pattern => pathname.includes(pattern));

    if (isNonReportPage) {
      // Clear the current report from the store
      useActiveReportStore.setState({
        currentReport: undefined,
        currentReportId: undefined,
      });
    }
  }, [location.pathname]);
};
